import { render, staticRenderFns } from "./techrequirementsItem.vue?vue&type=template&id=3e2dd84b&"
import script from "./techrequirementsItem.vue?vue&type=script&lang=js&"
export * from "./techrequirementsItem.vue?vue&type=script&lang=js&"
import style0 from "./techrequirementsItem.vue?vue&type=style&index=0&id=3e2dd84b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports